var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3C12.6272 3 13.7082 3.44777 14.5052 4.2448C15.3022 5.04183 15.75 6.12283 15.75 7.25C15.75 8.37717 15.3022 9.45817 14.5052 10.2552C13.7082 11.0522 12.6272 11.5 11.5 11.5C10.3728 11.5 9.29183 11.0522 8.4948 10.2552C7.69777 9.45817 7.25 8.37717 7.25 7.25C7.25 6.12283 7.69777 5.04183 8.4948 4.2448C9.29183 3.44777 10.3728 3 11.5 3ZM11.5 13.625C16.1962 13.625 20 15.5269 20 17.875V20H3V17.875C3 15.5269 6.80375 13.625 11.5 13.625Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2eb2c1296a2af42fef067eecbd19c304.svg";
export { ForwardRef as ReactComponent };